<div class="social-review-runtime text-box-container">
  <div class="question-header">
    <h6 class="m-0 p-0"
      [style.font-size]="questionnaire?.mainContentTemplate?.questionStyle?.fontSize + 'px'"
      [style.font-family]="questionnaire?.mainContentTemplate?.questionStyle?.fontFamily"
      [style.font-weight]="questionnaire?.mainContentTemplate?.questionStyle?.boldStyle"
      [style.color]="questionnaire?.mainContentTemplate?.questionStyle?.fontColor">
      {{ questionNumber }}. {{ question?.question || 'Share your experience' | titlecase }}
      @if (question?.required) {
        <span
          [style.font-size]="'18px'"
          [style.font-family]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontFamily"
          [style.font-weight]="questionnaire?.mainContentTemplate?.errorMessageStyle?.boldStyle"
          [style.color]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontColor">*</span>
      }
    </h6>
  </div>
  @if (showRatingStars) {
    <div class="social-review-runtime__rating">
      <div class="social-review-runtime__stars buttons-row" aria-label="5 star rating">
        @for (i of ratingStars; track i) {
          <button
            type="button"
            class="rating-icon p-0"
            [class.text-primary]="selectedRating !== null && selectedRating >= i"
            (click)="selectRating(i, $event)"
            [disabled]="disabled">
            <span class="rating-icon-inner">
              <i class="fa-star"
                [class.fa-solid]="selectedRating !== null && selectedRating >= i"
                [class.fa-regular]="selectedRating === null || selectedRating < i"
                aria-hidden="true"></i>
            </span>
          </button>
        }
      </div>
    </div>
  }
  @if (isInvalid && errorMessage) {
    <p class="error-message m-0 mt-2"
      [style.color]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontColor">
      {{ errorMessage | titlecase }}
    </p>
  }
</div>
